// src/components/Loader/Loader.js
import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './Loader.css';

const Loader = () => {
  const antIcon = (
    <LoadingOutlined 
      style={{ 
        fontSize: 48,
        color: '#1b3b86'
      }} 
      spin 
    />
  );

  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <div className="loader-content">
          <div className="logo-container">
            <img 
              src="/logo.png" 
              alt="NexusFlow" 
              className="loader-logo"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div className="logo-fallback" style={{display: 'none'}}>
              <span className="company-name">NEXUSFLOW</span>
            </div>
          </div>
          <Spin indicator={antIcon} className="loader-spinner" />
          <div className="loader-text">
            <span className="loading-dots">
              <span>Loading Excellence</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
            </span>
          </div>
          <div className="loader-progress">
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;